// Gestión de consentimiento de cookies (RGPD / LSSI-CE)
export type CookieCategory = "necessary" | "analytics" | "marketing";

export interface CookieConsent {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  timestamp: string;
  version: number;
}

const STORAGE_KEY = "ll_cookie_consent";
const CONSENT_VERSION = 1;
const EVENT_NAME = "ll:cookie-consent-change";

export const getCookieConsent = (): CookieConsent | null => {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CookieConsent;
    if (parsed.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const saveCookieConsent = (
  prefs: Pick<CookieConsent, "analytics" | "marketing">
) => {
  const consent: CookieConsent = {
    necessary: true,
    analytics: prefs.analytics,
    marketing: prefs.marketing,
    timestamp: new Date().toISOString(),
    version: CONSENT_VERSION,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: consent }));
  return consent;
};

export const acceptAllCookies = () =>
  saveCookieConsent({ analytics: true, marketing: true });

export const rejectAllCookies = () =>
  saveCookieConsent({ analytics: false, marketing: false });

export const resetCookieConsent = () => {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: null }));
};

export const onConsentChange = (cb: (c: CookieConsent | null) => void) => {
  const handler = (e: Event) => cb((e as CustomEvent).detail);
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
};
